// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Md5 } from 'ts-md5';
export class WorkSpaceUserKey {
    constructor(Login, ConnectionName, UserStorrageType = WorkSpaceUserStorageType.TE) {
        this.Login = '';
        this.ConnectionName = '';
        this.UserStorrageType = WorkSpaceUserStorageType.TE;
        this.Login = Login;
        this.ConnectionName = ConnectionName;
        this.UserStorrageType = UserStorrageType;
    }
    getKey() {
        return Md5.hashStr(`${this.Login}-${this.ConnectionName}-${this.UserStorrageType}`);
    }
}
export var WorkSpaceUserStorageType;
(function (WorkSpaceUserStorageType) {
    WorkSpaceUserStorageType[WorkSpaceUserStorageType["TE"] = 0] = "TE";
    WorkSpaceUserStorageType[WorkSpaceUserStorageType["TVTradingPlatform"] = 1] = "TVTradingPlatform";
    WorkSpaceUserStorageType[WorkSpaceUserStorageType["TE_WEB_MOBILE"] = 2] = "TE_WEB_MOBILE";
})(WorkSpaceUserStorageType || (WorkSpaceUserStorageType = {}));
